"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What kind of European items do you carry in the market?",
  answer: "Our market features a curated selection of imported chocolates, specialty jams, premium olive oils, and unique pantry staples from across Europe, alongside local artisanal goods."
}, {
  question: "Do you offer gluten-free or dairy-free options?",
  answer: "Yes, we offer several gluten-free pastry options and dairy-free milk alternatives like oat and almond for all our coffee and matcha drinks. Please ask our baristas for today's selection."
}, {
  question: "Can I order sandwiches or platters for a local event?",
  answer: "Certainly! We offer catering platters featuring our signature focaccia deli sandwiches and pastry assortments. Contact us directly to discuss your event needs in Enfield."
}, {
  question: "What makes your matcha special?",
  answer: "We source high-grade ceremonial matcha and prepare it traditionally to ensure a smooth, vibrant flavor profile that pairs perfectly with our house-made syrups."
}, {
  question: "Are your focaccia sandwiches made fresh?",
  answer: "Our focaccia bread arrives fresh from a trusted local bakery, and we assemble each sandwich in-house with our premium deli meats and imported cheeses."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221697" id="common-questions" className="bg-background text-foreground relative py-24 sm:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-accent/10 pointer-events-none" />

      <div ref={ref} className={`relative z-10 mx-auto max-w-3xl px-6 lg:px-8 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl font-semibold tracking-tight sm:text-4xl mb-4 text-foreground">
            Common Questions
          </h2>
          <p className="font-default text-muted-foreground text-lg">
            Everything you need to know about our café, market, and artisanal offerings in Enfield.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-border/60 py-2">
              <AccordionTrigger className="font-default text-lg text-left font-semibold hover:text-secondary transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-default text-base text-muted-foreground/90 leading-relaxed pt-2 pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}